module.exports = __webpack_public_path__ + "images/183_320.jpg";